import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { NeuInput, NeuSelect } from "../../components/neu/Neu";

const ROLES = ["company_admin", "system_admin", "branch_manager", "employee"];

// شريط بحث + فلترة بالدور — يعمل بحث فوري داخل الفريق فقط.
export const EmployeesSearch = ({ query, setQuery, role, setRole }) => {
  const { t } = useTranslation();
  return (
    <div className="neu p-3" data-testid="employees-search">
      <div className="grid gap-3 sm:grid-cols-[1fr_220px]">
        <div className="relative">
          <Search className="pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground start-4" />
          <NeuInput
            data-testid="employees-search-input"
            placeholder={t("employees.search")}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="ps-11"
          />
        </div>
        <NeuSelect
          data-testid="employees-role-filter"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">{t("employees.filter.all")}</option>
          {ROLES.map((r) => (
            <option key={r} value={r}>
              {t(`roles.${r}`)}
            </option>
          ))}
        </NeuSelect>
      </div>
    </div>
  );
};
